import React from 'react';
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'outline' | 'secondary';
  size?: 'sm' | 'md' | 'lg';
}
export function Button({
  className,
  variant = 'primary',
  size = 'md',
  children,
  ...props
}: ButtonProps) {
  const variants = {
    primary: 'bg-primary text-white hover:bg-opacity-90 border border-transparent',
    secondary: 'bg-secondary text-white hover:bg-opacity-90 border border-transparent',
    outline: 'bg-transparent border border-text text-text hover:bg-text hover:text-white'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg'
  };
  return <button className={cn('inline-flex items-center justify-center rounded transition-all duration-200 font-sans font-semibold focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2', variants[variant], sizes[size], className)} {...props} data-id="element-86">
      {children}
    </button>;
}